import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K2PdfPageSelectionEdit } from "./edit";
import { K2PdfPageSelectionNew } from "./new";
import { K2PdfPageSelectionTable } from "./table";

export default function K2PdfPageSelection() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Sélection de pages PDF");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K2PdfPageSelectionEdit />} />
      <Route index element={<K2PdfPageSelectionTable />} />
      <Route path="/new" element={<K2PdfPageSelectionNew />} />
    </Routes>
  );
}
